// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__2dZxe","hasLoaded":"Image_hasLoaded__2eGzf"};